var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['ts', 'reveal'],style:(_vm.getBg())},[_c('div',{staticClass:"tsContainer"},[_c('div',{staticClass:"tsBoxes"},[_c('testimonialboxes',{attrs:{"interactive":true,"items":_vm.sectionData.items}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }